import { ChangeEvent, useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import { deleteFile } from "../../auth/authSlice";

import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Fab from "@mui/material/Fab";
import Badge from "@mui/material/Badge";
import Paper from "@mui/material/Paper";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import Box from "@mui/material/Box";
import Toast from "../../../components/Layout/Toast";
import { PhotoTypes } from "../types/processTypes";
import { selectProcesses, uploadPicture } from "../processSlices";
import { resizeFile } from "../../../utils/imageUtility";
import { Typography } from "@mui/material";
import { Photo } from "@mui/icons-material";

function MedicalPhoto() {
  const [image, setImage] = useState("");

  const {
    selectedEmployee,
    success,
    loading: loadingMedicalPhoto,
    error,
  } = useAppSelector(selectProcesses);
  const dispatch = useAppDispatch();
  const onChangeMedical = async (event: ChangeEvent<HTMLInputElement>) => {
    const { validity, files } = event.target;

    if (validity.valid && files && files[0]) {
      const image = (await resizeFile(files[0], 1000, 1000)) as File;
      if (image) {
        dispatch(
          uploadPicture({
            _id: selectedEmployee!._id as string,
            type: PhotoTypes.Medical,
            avatar: image,
          }),
        );
      }
    }
  };

  const removeImage = () => {
    setImage("");
    dispatch(deleteFile(selectedEmployee?.medicalPhoto as string));
  };

  useEffect(() => {
    if (loadingMedicalPhoto === "pending") {
      document.body.style.opacity = "0.5";
    } else {
      document.body.style.opacity = "1";
    }
  }, [loadingMedicalPhoto]);

  return (
    <>
      <Paper
        elevation={0}
        style={{
          position: "relative",
          borderRadius: 18,
          display: "flex",
          justifyContent: "flex-start",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <input
          name="medicalImage"
          accept="image/*"
          onChange={onChangeMedical}
          style={{ display: "none" }}
          id="icon-button-file-medical"
          type="file"
        />
        <label htmlFor="icon-button-file-medical">
          <>
            <Badge
              overlap="rectangular"
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              badgeContent={
                <Tooltip
                  title="Add/Change Photo"
                  aria-label="icon-button-file-medical"
                >
                  <Fab component="span" color="primary">
                    <IconButton
                      aria-label="icon-button-file-medical"
                      component="span"
                      size="large"
                      color="inherit"
                    >
                      <Photo />
                    </IconButton>
                  </Fab>
                </Tooltip>
              }
            >
              <Avatar
                alt="medical"
                variant="rounded"
                src={
                  image
                    ? image
                    : selectedEmployee
                      ? selectedEmployee.medicalPhoto
                      : ""
                }
                sx={{
                  height: 180,
                  width: 100,
                }}
              >
                <Typography variant="h5" sx={{ px: 10, py: 40 }}>
                  Add Medical
                </Typography>
              </Avatar>
            </Badge>
          </>
        </label>{" "}
        <Box m={1}>
          {error && <Toast severity="error">{error.message}</Toast>}
          {success && <Toast severity="success">{success.message}</Toast>}
        </Box>
      </Paper>
    </>
  );
}

export default MedicalPhoto;
